"use strict";

var ga = require('../ga.constants');
module.exports = /*@ngInject*/function ($window, $http, ENV, ConfigService, SideMenuService, BrandService, ProfileService) {
  var ctrl = this;
  ctrl.title = ConfigService.getConfig().SITE_TITLE;
  ctrl.environment = ENV;
  ctrl.helpKey = 'inspect';
  ctrl.defaultMenuOpen = false; //Set Default Per Application
  ctrl.profile = ProfileService.getProfile();
  ctrl.menuItems = SideMenuService.getMenu();
  ctrl.tenant = {};
  if (ctrl.profile) {
    BrandService.initialize().then(function (tenant) {
      ctrl.tenant = tenant;
      ctrl.setAppHeader(ctrl.tenant.brand.favicon || 'favicon.ico');
    });
  }
  ctrl.setAppHeader = function (favicon) {
    // eslint-disable-next-line no-undef
    var myElement = angular.element(document.querySelector('#favicon'));
    myElement.attr('href', myElement.attr('href').replace(new RegExp('/[w]*[W]*favicon[.]ico'), "/".concat(favicon)));
  };
  ctrl.active = function () {
    return SideMenuService.active;
  };
  ctrl.getSidemenuEvent = function (label) {
    return [ga.categories.SIDEMENU, ga.actions.NAVIGATE, label];
  };
  ctrl.getNotificationCount = function () {
    if (ctrl.profile) {
      var countRequest = {
        method: 'GET',
        url: "".concat(ctrl.tenant.serviceMap.notification.contextUrl, "api/header/count"),
        params: {
          eppn: ctrl.profile.identifiers.authId,
          authId: ctrl.profile.identifiers.authId
        }
      };
      $http(countRequest).then(function (response) {
        ctrl.showNotifications = true;
        ctrl.notificationsCount = response.data.count;
      });
    }
  };
  ctrl.openNotificationInbox = function () {
    // eslint-disable-next-line no-param-reassign
    $window.location.href = ctrl.tenant.serviceMap.notification.contextUrl;
  };
  ctrl.events = {
    header: [ga.categories.HEADER, ga.actions.NAVIGATE, ga.labels.HOME],
    sidemenu: {
      Inspect: ctrl.getSidemenuEvent(ga.labels.HOME),
      Reports: ctrl.getSidemenuEvent(ga.labels.REPORTS),
      /* 'Open Findings': ctrl.getSidemenuEvent(ga.labels.OPEN_FINDINGS),*/
      Management: ctrl.getSidemenuEvent(ga.labels.MANAGEMENT),
      Resources: ctrl.getSidemenuEvent(ga.labels.RESOURCES)
    }
  };
  ctrl.signOut = function () {
    var Amplify = $window.aws_amplify;
    Amplify.Auth.signOut();
  };
};